import { CMS_Content_Module_TourSelectionData } from './types';
import { Button, Heading } from '@cue/atoms';
import { useHash } from '@cue/hooks';
import { StyledComponent } from '@cue/theme';
import styled, { CSSObject } from '@emotion/styled';
import { CardDeck } from '@project/cms/modules/card-deck';
import { CMS_Content_Module_Text_Image } from '@project/cms/modules/text-image';
import { CMS_Content_Modules_Enum } from '@project/cms/modules/types';
import { navigate } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const TourSelection: React.FC<
  TourSelectionProps & StyledComponent<TourSelectionCSSOverride>
> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { tours, link_type, ...rest } = props;
  const { title, title_position = 'center' } = rest;
  const {
    i18n: { language },
  } = useTranslation();

  const { updateHash: updateHash } = useHash();

  /*   const match = useMatch('/en/showroom/*');
  const location = useLocation();
  const experienceMatch = new URLSearchParams(location.search).get('experience');
  console.log('matchmatchmatchmatch', new URLSearchParams(location.search).get('experience'));

  const stateHandler = {
    setState: (url: string) => {
      return navigate(`${path.replace(':id', '')}?experience=${url}#showroom`); //${location.hash ? `${location.hash}` : ''}
    },
    state: experienceMatch,
    initState: '',
  }; */

  return (
    <Container className="cue-tour-selection">
      {title ? (
        <Heading type="h2" className={`section-headline section-headline--${title_position}`}>
          {title}
        </Heading>
      ) : null}

      <TourSelector>
        <CardDeck
          as_slider={true}
          card_modules={parseTourToModule(tours, rest, language, updateHash)}
        />
      </TourSelector>
    </Container>
  );
};
const parseTourToModule = (
  tours: TourSelectionProps['tours'],
  rest: Omit<TourSelectionProps, 'tours'>,
  language: string,
  updateHash: (value: string | null | undefined) => void,
): CMS_Content_Module_Text_Image[] => {
  return tours.map(({ image, title, description, scene }) => ({
    type: CMS_Content_Modules_Enum.TextImage,
    data: {
      headline: title,
      text: description,
      image: image?.src || 'https://placehold.co/600x400',
      onClick: () => {
        if (document.location.pathname === `/${language}${rest.target_path}`) {
          navigate(`/${language}${rest.target_path}?experience=${scene}#showroom`);
          //  navigate(`/${language}${rest.target_path}?experience=${scene}`);
          // updateHash(scene);

          setTimeout(() => {
            // SCROLL INTO VIEW
            const el = document?.getElementById(`/showroom`);
            if (el) {
              window.scrollTo({
                behavior: 'smooth',
                top: el.getBoundingClientRect().top - document.body.getBoundingClientRect().top,
              });
            }
          }, 10);
        } else {
          navigate(`/${language}${rest.target_path}?experience=${scene}`);
        }
      },
      customFooter: () => (
        <Button
          onClick={() => {
            if (document.location.pathname === `/${language}${rest.target_path}`) {
              navigate(`/${language}${rest.target_path}?experience=${scene}#showroom`);
              /* updateHash(scene); */

              setTimeout(() => {
                // SCROLL INTO VIEW
                const el = document?.getElementById(`/showroom`);
                if (el) {
                  window.scrollTo({
                    behavior: 'smooth',
                    top: el.getBoundingClientRect().top - document.body.getBoundingClientRect().top,
                  });
                }
              }, 10);
            } else {
              navigate(`/${language}${rest.target_path}?experience=${scene}`);
            }

            //navigate(`/${language}${rest.target_path}#${scene}`)
          }}
          styling="iconOnlyColored"
          icon="arrowRightSecondary"
        />
      ),
    },
  }));
  return [];
};
export type TourSelectionCSSOverride = {
  '.cue-tour-selection'?: CSSObject;
};
export type TourSelectionProps = CMS_Content_Module_TourSelectionData;
const Container = styled.div``;
const TourSelector = styled.div`
  margin: 2rem 0;
`;
